/*
 * <sticky-add-to-cart>
 *
 * Mobile sticky add-to-cart bar for the product page. It does not own any cart
 * logic: clicking its button forwards to the real product form submit button,
 * so Dawn's product-form.js (single add) and the CHAG <product-addons>
 * multi-item AJAX flow both keep working.
 *
 * The bar reveals itself once the main add-to-cart button scrolls out of view
 * (IntersectionObserver), and mirrors the main button's disabled / label state
 * (MutationObserver) so a sold-out variant disables the sticky button too.
 */
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.stickyButton = this.querySelector('[data-sticky-atc-button]');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        if (!this.stickyButton || !this.mainButton) return;

        this.stickyButton.addEventListener('click', this.onClick.bind(this));

        this.setupVisibilityObserver();
        this.setupStateObserver();
        this.syncState();
      }

      disconnectedCallback() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
      }

      onClick() {
        // Forward to the real button so the existing submit handlers fire.
        this.mainButton.click();
      }

      setupVisibilityObserver() {
        // Reveal the bar only once the main button has scrolled out of view.
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.hidden = entry.isIntersecting;
            });
          },
          { rootMargin: '0px', threshold: 0 }
        );
        this.intersectionObserver.observe(this.mainButton);
      }

      setupStateObserver() {
        // Mirror disabled state + label from the main button.
        this.mutationObserver = new MutationObserver(() => this.syncState());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });
      }

      syncState() {
        const disabled =
          this.mainButton.hasAttribute('disabled') ||
          this.mainButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = disabled;

        const mainLabel = this.mainButton.querySelector('span:not(.loading__spinner)');
        if (mainLabel && mainLabel.textContent.trim()) {
          this.stickyButton.textContent = mainLabel.textContent.trim();
        }
      }
    }
  );
}
